const appBaseUrl =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? process.env.REACT_APP_API_URL_PROD
        : process.env.REACT_APP_API_URL_DEV;

const apiUrlV5_0_1 = `${appBaseUrl}api/v5.0.1`;
const apiUrlV5_0_3 = `${appBaseUrl}api/v5.0.3`;

const imgUrl =
    process.env.REACT_APP_AWS_ASSETS_ROOT_URL;
export default {
    config: {
        appBaseUrl: apiUrlV5_0_1,
        appBaseUrlV5_0_3: apiUrlV5_0_3,
        imgUrl,
    },
};
